<template >
  <div name="documents">
    <div class="flex justify-between mb-4">
      <h2 class="text-gray-500 uppercase">Videos</h2>
      <button
        @click="addNew()"
        type="button"
        class="text-action-blue opacity-75 cursor-pointer hover:opacity-50 wide focus:outline-none"
      >
        <i class="fas fa-plus-circle mr-2 text-xl"></i>
      </button>
    </div>

    <div class="table-wrapper">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div id="content-area" class="w-full mx-auto" v-else>
        <div
          style="width: 100%; text-align: center"
          class="spin-holder mt-4"
          v-if="loading"
        >
          <i class="spinner fa fa-spinner fa-spin"></i>
          <p>Loading Videos</p>
        </div>

        <div v-else>
          <div v-if="componentLoaded">
              <table class="table-wrapper w-95p bg-white rounded shadow-sm">
                <tbody>
                  <tr v-for="(item, index) in videosList" :key="index">
                    <td
                      @click="displayResource(item)"
                      class="cursor-point w-1/12 pl-2"
                    >
                      <i class="icon " v-bind:class="showIcon(item)"></i>
                    </td>

                    <td
                      @click="displayResource(item)"
                      class="cursor-pointer w-7/12"
                    >
                      {{ item.title }}
                    </td>

                    <td
                      class="text-xs cursor-pointer text-blue-400 w-1/12 left"
                    >
                      <template v-if="isOwnedDocument(item)">
                        <i
                          class="fas fa-ellipsis-h hover:opacity-75 pl-4"
                          @click="selectToDelete(item)"
                        ></i>

                        <transition
                          enter-active-class="transition duration-300 ease-out transform"
                          nter-class="-translate-y-3 scale-95 opacity-0"
                          enter-to-class="translate-y-0 scale-100 opacity-100"
                          leave-active-class="transition duration-150 ease-in transform"
                          leave-class="translate-y-0 opacity-100"
                          leave-to-class="-translate-y-3 opacity-0"
                        >
                          <div v-show="showDelete(item)" class="absolute pt-2">
                            <div
                              class="relative py-1 bg-white border border-gray-200 rounded-md shadow-xl"
                            >
                              <div
                                class="absolute top-0 w-4 h-4 origin-center transform rotate-45 translate-x-5 -translate-y-2 bg-white border-t border-l border-gray-200 rounded-sm pointer-events-none"
                              ></div>
                              <div class="relative">
                                <a
                                  class="block w-full px-4 py-2 font-medium text-gray-700 whitespace-no-wrap hover:bg-gray-100 focus:outline-none hover:text-gray-900 focus:text-gray-900 focus:shadow-outline transition duration-300 ease-in-out"
                                  @click="displayResource(item)"
                                  >View</a
                                >
                                <a
                                  @click="deleteResource(item)"
                                  class="block w-full px-4 py-2 font-medium text-red-500 whitespace-no-wrap hover:bg-gray-100 focus:outline-none hover:text-gray-900 focus:text-gray-900 focus:shadow-outline transition duration-300 ease-in-out"
                                  >Delete</a
                                >
                                <a
                                  @click="cancelSelect()"
                                  class="block w-full px-4 py-2 font-medium text-blue-500 whitespace-no-wrap hover:bg-gray-100 focus:outline-none hover:text-gray-900 focus:text-gray-900 focus:shadow-outline transition duration-300 ease-in-out"
                                  >Cancel</a
                                >
                              </div>
                            </div>
                          </div>
                        </transition>
                      </template>
                      <template v-else>
                        <i
                          v-if="!currentUser.isSubscriber"
                          class="fas fa-lock text-yellow-500 text-lg pl-2"
                        ></i>
                        <a v-else class="ml-4" @click="displayResource(item)"
                          >View</a
                        >
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
        
          </div>
          <p class="m-1" v-else>
            We could not find any data for your given selection.
          </p>
        </div>
      </div>
    </div>

    <modalvideo
      :url="loadVideoPath()"
      @close="showModalVideo = false"
      v-if="selectedVideo != undefined && showModalVideo"
      v-show="showModalVideo"
    ></modalvideo>

    <ModalSlide :show="showModalAddition" @closeModal="closeAddResource">
      <template v-slot:header-icon>
        <i class="fas fa-plus"></i>
      </template>
      <template v-slot:header-title>
        Add New Video
        <div class="text-xs">Enter details for new video file.</div>
      </template>
      <template v-slot:body>
        <VideoAdd
          :course="course"
          :lesson="lesson"
          :displayKey="displayKey"
          @resource-added="resourceAdded"
        ></VideoAdd>
      </template>
    </ModalSlide>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";
import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";

const ModalSlide = () => import("@/components/ModalSlide.vue");
const VideoAdd = () => import("@/components/library/TheVideoAdd.vue");

const modalvideo = () => import("@/components/ModalVideo.vue");

export default {
  name: "documents",
  mixins: [fileResourceMixin],
  props: {
    course: Object,
    lesson: { type: Object, required: false },
    displayKey: { type: String, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.videosList.length > 0;
    },
    videosList() {
      var vm = this;
      let docs = vm.videos.filter(function (r) {
        return  r.display_key === vm.displayKey;
      });

      return _.orderBy(docs, [vm.sortBy], [vm.sortDirection]);
    },
  },
  data() {
    return {
      loading: true,
      errored: false,

      selectedVideo: {},
      showModalVideo: false,
      showModalAddition: false,
      videos: [],
      isMenuVisible: false,
    };
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.lessonVideos();
  },
  methods: {
    lessonVideos() {
      this.loading = true;
      SchoolService.getAll("lessons/" + this.lesson.id + "/videos")
        .then((response) => this.buildVideos(response.data))
        .catch((err) => {
          console.log("resources " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildVideos(data) {
      this.videos = data.data;
    },
    showIcon(video) {
      if (video.service_type === "youtube") {
      return "fas fa-tv";
      } else {
        return "fas fa-file-video";
      }
    },
    isOwnedDocument(video) {
      let owned = (video.school_id === null || video.school_id === undefined) ? 1 : video.school_id
      return owned === this.currentUser.id;
    },
    displayResource(document) {
      this.selectedVideo = document;
      this.isMenuVisible = false;
      this.showModalVideo = true;
    },
    loadVideoPath() {
      if (this.selectedVideo.service_type === "youtube") {
        return this.selectedVideo.service_url_a;
      } else {
        return this.selectedVideo.service_url_b;
      }
     
    },
    addNew() {
      this.showModalAddition = true;
    },
    closeAddResource() {
      this.showModalAddition = false;
    },
    resourceAdded() {
      this.closeAddResource();
      this.lessonVideos();
    },
    selectToDelete(video) {
      this.selectedVideo = video;
      this.isMenuVisible = true;
    },
    showDelete(video) {
      return (
        this.isMenuVisible === true &&
        this.selectedVideo.identifier === video.identifier
      );
    },
    deleteResource(video) {
      var vm = this;

      SchoolService.delete("videos", video.identifier)
        .then((response) => {
          vm.lessonVideos();
          vm.cancelSelect();
        })
        .catch((err) => {
          console.log(err);
          vm.failure(err);
        });
    },
    failure(err) {
      this.cancelSelect();
      throw new Error(`Resources failure error: ${err}`);
    },
    cancelSelect() {
      this.isMenuVisible = false;
      this.selectedVideo.identifier = undefined;
    },
  },
  components: {
    modalvideo,
    VideoAdd,
    ModalSlide,
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>


